// extracted by mini-css-extract-plugin
module.exports = {"description":"OutletDescriptions_description__jfEUl","additionalInfoBody":"OutletDescriptions_additionalInfoBody__onoQ6"};